<template>
    <div class="pa-2">
        <v-alert
            v-if="item.id && item.status == 'Pendente' && !can('Edita imóvel pendente', { item: item })"
            type="error"
        >
            Voce não possui permissão para editar esse imóvel pendente. Por favor, entre em contato a gerência
        </v-alert>

        <div
             v-else-if="item.id && item.status == 'Ativo' && !can('Edita imóvel ativo da carteira', { item: item })"
        >
            {{ can('Edita imóvel ativo da carteira', { item: item }) }}

            <v-alert
                type="error"
            >
                Voce não possui permissão para editar esse imóvel ativo. Voce poderá solicitar alterações à gerência clicando no botão "Solicitar Alteração".
            </v-alert>
            <div
                class="text-center"
            >
                <v-btn
                    dark
                    color="purple"
                    @click="openUserRequest('user_requests')"
                    :class="$css_button"
                >
                    SOLICITAR ALTERAÇÃO
                </v-btn>
            </div>
        </div>

        
        <div v-else>
            <v-card 
                v-if="item.id"
                class="pa-4 ma-0" 
                outlined
            >
                <div class="text-h6">Imóvel - Código {{ item.codigo }} </div>

                <v-tabs
                    v-model="active_tab"
                    show-arrows 
                >
                    <v-tab href="#tab-10" class="caption"> Endereço, Tipo de Imóvel...</v-tab>
                    <v-tab href="#tab-20" class="caption"> Dorm, Area, Valores...</v-tab>
                    <v-tab href="#tab-30" class="caption" v-if="item.tipo_imovel != 'Terreno' && item.tipo_imovel != 'Área'"> Área Privativa</v-tab>
                    <v-tab href="#tab-40" class="caption"> Infra</v-tab>
                    <v-tab href="#tab-50" class="caption" v-if="item.tipo_imovel != 'Terreno' && item.tipo_imovel != 'Área'"> Lazer </v-tab>
                    <v-tab href="#tab-60" class="caption"> Colaboradores </v-tab>
                    <v-tab href="#tab-70" class="caption"> Locais </v-tab>
                    <v-tab href="#tab-80" class="caption"> Fotos </v-tab>
                    <v-tab href="#tab-90" class="caption"> Publicidade </v-tab>
                    <v-tab href="#tab-100" class="caption"> Videos </v-tab>
                    <v-tab href="#tab-110" class="caption"> Placa </v-tab>
                    <v-tab href="#tab-120" class="caption"> Portais </v-tab>
                    <v-tab href="#tab-130" class="caption"> Proprietário </v-tab>
                    <v-tab href="#tab-140" class="caption"> Status </v-tab>
                    <v-tab href="#tab-150" class="caption"> Arquivos </v-tab>
                    <v-tab href="#tab-200" class="caption" @click="loadPromisseAudits()"> Histórico </v-tab>
                </v-tabs>
            
                <v-tabs-items v-model="active_tab">
                    <v-tab-item value="tab-10">
                        <v-card flat class="pa-8">
                            <main-form :object="item" />
                        </v-card>   
                    </v-tab-item>   

                    <v-tab-item value="tab-20">
                        <v-card flat class="pa-8">
                            <price-form :object="item" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-30">
                        <v-card flat class="pa-8">
                            <property-item :object="private_areas" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-40">
                        <v-card flat class="pa-8">
                            <property-item :object="infrastructures" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-50">
                        <v-card flat class="pa-8">
                            <property-item :object="recreations" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-60">
                        <v-card flat class="pa-8">
                            <colaborator-form :object="colaborators" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-70">
                        <v-card flat class="pa-8">
                            <place-form :object="places" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-80">
                        <v-card flat class="pa-8">
                            <drop-zone :object="photos" @callSetPropertyPhotosTotal="setPropertyPhotosTotal" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-90">
                        <v-card flat class="pa-8">
                            <publicity-form :object="item" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-100">
                        <v-card flat class="pa-8">
                            <video-form :object="videos" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-110">
                        <v-card flat class="pa-8">
                            <board-form :object="boards" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-120">
                        <v-card flat class="pa-8">
                            <portal-form :object="portals" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-130">
                        <v-card flat class="pa-8">
                            <property-owner-form :object="property_owners" @callSetPropertyOwnerItems="setPropertyOwnerItems" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-140">
                        <v-card flat class="pa-8">
                            <status-form :object="item" @callOpenUserRequest="openUserRequest" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-150">
                        <v-card flat class="pa-8">
                            <upload-form :object="files" />
                        </v-card>    
                    </v-tab-item>

                    <v-tab-item value="tab-200">
                        <v-card flat class="pa-8">
                            <audit-component :object="audits.items" @callLoadPromisseAudits="loadPromisseAudits" />
                        </v-card>    
                    </v-tab-item>

                </v-tabs-items>
            </v-card>
        </div>


        <!-- Dialog -->
        <v-dialog 
            class="d-print-none"
            v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
                class="d-print-none"
            >    
            </v-system-bar>    

            <v-card class="d-print-none" >
                <v-card-title class="text-h5">

                    <span v-if="dialog_model == 'user_requests'">
                        Solicitação de alteração de imóvel
                    </span>
                    
                    <span v-if="item.codigo" class="ml-2">- Código {{ item.codigo }} </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="openCloseDialog('user_requests')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <store-user-request-component v-if="dialog_model == 'user_requests'" :object="user_requests"></store-user-request-component>
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->


    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import { COLABORATOR_DESCRIPTION_ITEMS } from './config_properties/config_properties.js';
import MainForm from './MainForm.vue';
import PriceForm from './PriceForm.vue';
import PropertyItem from '@/components/property_items/PropertyItemComponent.vue';
import ColaboratorForm from '@/components/colaborators/ColaboratorForm.vue';
import PlaceForm from '@/components/places/PlaceForm.vue';
import DropZone from '@/components/dropzone/DropZone.vue';
import PublicityForm from './PublicityForm.vue';
import VideoForm from '@/components/videos/VideoForm.vue';
import BoardForm from '@/components/boards/BoardForm.vue';
import PortalForm from '@/components/portals/PortalForm.vue';
import PropertyOwnerForm from '@/components/property_owners/PropertyOwnerForm.vue'
import StatusForm from './StatusForm.vue';
import UploadForm from '@/components/upload/UploadForm.vue';
import AuditComponent from '@/components/audits/AuditComponent.vue'
import StoreUserRequestComponent from '@/components/user_requests/partials/StoreUserRequestComponent.vue'

export default {
    name: 'PropertyEdit',

    components: {
        MainForm,
        PriceForm,
        PropertyItem,
        ColaboratorForm,
        PlaceForm,
        DropZone,
        PublicityForm,
        VideoForm,
        BoardForm,
        PortalForm,
        PropertyOwnerForm,
        StatusForm,
        UploadForm,
        AuditComponent,
        StoreUserRequestComponent
    },

    mounted() {
        window.scrollTo(0, 0);
    },       

    data() {
        return {
            active_tab: 'tab-10',

            dialog: false,
            dialog_model: null,

            item: {
                id: null,
                colaborators: null
            },   // ← variável local para armazenar o resultado

            private_areas: {
                title: "",
                model: "properties",
                model_property: "private_areas",
                order: "description",
                method: "storePrivateArea",
                item_id: "",
                items: []     
            },

            infrastructures: {
                model: "properties",
                model_property: "infrastructures",
                order: "description",
                method: "storeInfrastructure",
                tipos: [],
                regioes: [],
                item_id: "",
                items: [],
                editable: 'true' 
            },

            recreations: {
                model: "properties",
                model_property: "recreations",
                order: "description",
                method: "storeRecreation",
                tipos: [],
                regioes: [],
                item_id: "",
                items: [],
                editable: 'true'
            },

            colaborators: {
                model: "properties",
                descriptions: COLABORATOR_DESCRIPTION_ITEMS,
                item_id: "",
                items: []     
            },

            places: {
                model: "properties",
                item_id: "",
                cidade: "",
                estado: "",
                items: []     
            },

            photos:{
                model: 'properties',
                item_id: '',
                items: [],
                items_condominium: '',
                watermark: '',
                condominium_id: ''
            },

            videos:{
                model: 'properties',
                item_id: '',
                items: ''
            },

            boards:{
                model: 'properties',
                item_id: '',
                items: ''
            },

            portals: {
                item_id: '',
                items: []
            },

            property_owners: {
                property_id: '',
                items: []
            },

            files: {
                multiple: true,
                model: 'properties',
                item_id: '',
                items: [],
                extensions: '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg',
                label_extensions: 'File  (pdf, docx, xlsx e jpg)',
                description_text: false
            },

            audits: {
                items: []
            },

            user_requests: {
                model: 'properties',
                item_id: '',
                subject: 'Solicitação de alteração',
                object: {}
            },
            
        };
    },

    computed: {
        ...mapGetters('permissions', ['can']),

        tenant() {
            return this.$store.state.tenants.items.data    
        },
    },

    watch: {
        // Recarrega se o UUID mudar (navegação interna)
        '$route.params.uuid': {
            async handler(newUuid) {
                if (newUuid) {
                    try {
                        const result = await this.loadProperty(newUuid);
                        this.item = result.data;
                        this.setObject()
                    } catch (error) {
                        this.item = null;
                        console.error('Erro:', error);
                    } 
                }
            },
            immediate: true
        },

        /* 
        item: {
            handler(item) {
                if (item) this.setObject();
            },
            immediate: true,
            deep: true
        }
        */
    },

    methods: {
        ...mapActions(['loadProperty']),

        setObject(){
            this.private_areas.item_id = this.item.id
            this.private_areas.items = this.item.private_areas

            this.infrastructures.item_id = this.item.id
            this.infrastructures.items = this.item.infrastructures
            this.infrastructures.tipos = [this.item.tipo_imovel]
            this.infrastructures.regioes = [this.item.regiao]

            this.recreations.item_id = this.item.id
            this.recreations.items = this.item.recreations
            this.recreations.tipos = [this.item.tipo_imovel]
            this.recreations.regioes = [this.item.regiao]

            this.colaborators.item_id = this.item.id
            this.colaborators.items = this.item.colaborators

            this.places.item_id = this.item.id
            this.places.cidade = this.item.cidade
            this.places.estado = this.item.estado
            this.places.items = this.item.places

            // photos
            this.photos.item_id = this.item.id
            this.photos.condominium_id = this.item.condominium_id
            this.photos.items = this.item.photos
            this.photos.watermark = this.tenant[0].watermark

            // video
            this.videos.item_id = this.item.id
            this.videos.items = this.item.videos

            // boards
            this.boards.item_id = this.item.id
            this.boards.items = this.item.boards

            // portals
            this.portals.item_id = this.item.id
            this.portals.items = this.item.portals

            // property_owners
            this.property_owners.property_id = this.item.id
            this.property_owners.items = this.item.property_owners

            // files
            this.files.item_id = this.item.id
            this.files.items = this.item.files 

            if(this.item.condominium && this.item.condominium.id != ''){
                // infrastructures
                if(this.item.condominium.infrastructures && JSON.parse(this.item.condominium.infrastructures).length > 0){
                    this.infrastructures.items = JSON.parse(this.item.condominium.infrastructures); 
                }
                this.infrastructures.editable = 'false'
                // recreations
                if(this.item.condominium.recreations && JSON.parse(this.item.condominium.recreations).length > 0){
                    this.recreations.items = JSON.parse(this.item.condominium.recreations); 
                }
                this.recreations.editable = 'false'
                // photos
                if(this.item.condominium.condominium_photos && JSON.parse(this.item.condominium.condominium_photos).length > 0){
                    this.photos.items_condominium = JSON.parse(this.item.condominium.condominium_photos)
                }
            }
        },

        loadPromisseAudits(param = null){
            const params = {}
            params.model = 'properties'
            params.codigo = this.item.codigo

            if(param){
                if(param.page && param.page > 0){
                   params.page = param.page     
                }
                if(param.paginate && param.paginate > 0){
                   params.paginate = param.paginate     
                }
            }

            this.$store.dispatch('loadPromisseAudits', params)
                        .then(response => {
                            this.audits.items = response
                        })
                        .catch(error => {
                            console.log(error)
                        })
        },

        openUserRequest(model){ 
            if(model == 'user_requests'){
                this.user_requests.item_id = this.item.id;
                this.user_requests.object = this.item;
            }
            this.dialog = true;
            this.dialog_model = model;
        },

        openCloseDialog(){
            this.user_requests.item_id = null;
            this.user_requests.object = null;
            this.dialog_model = null;
            this.dialog = !this.dialog;
        },
        
        setPropertyOwnerItems(items){
            this.item.property_owners = items;
        },

        setPropertyPhotosTotal(items){
            const photosTotal = this.item.photos_total;

            // Verifica se existe (não é null, undefined, etc.)
            if (photosTotal === undefined || photosTotal === null) {
                this.item.photos_total = items;
            }

            // Verifica se é um array
            if (Array.isArray(photosTotal)) {
                // Se for array, verifica se o tamanho é zero
                if (photosTotal.length === 0) {
                    this.item.photos_total = items;
                }
            } else {
                this.item.photos_total = items;
            }
        }
          
    }    
    
};

</script>